import { formatMoney } from 'accounting';
import * as React from 'react';
import { connect } from 'react-redux';
import { IStore } from '../../../common/type';
import { BusyContainer } from '../../../components/BusyContainer';
import { Button, ButtonContainer } from '../../../components/Button';
import { Panel } from '../../../components/Panel';
import { is } from '../../../util/is';
import { adsCheckoutActionCreator } from '../parts/ads-checkout-action';
import {
  selectAds,
  selectCustomerName,
  selectErrorMessage,
  selectIsBusy,
  selectIsError,
  selectTotal
} from '../parts/ads-checkout-selector';
import { IAdsInfo } from '../parts/ads-checkout-type';
import './AdsSelectionPage.scss';
import { AdsSelectionRecord } from './AdsSelectionRecord';

class AdsSelectionPageContainer extends React.Component<IProps> {
  render() {
    const props = this.props;
    return (
      <main className="page">
        <h1>Ads Selection Page</h1>
        {props.error && (
          <Panel type="error" role="alert" data-testid="error-panel">
            {props.error}
          </Panel>
        )}
        <BusyContainer isBusy={props.isBusy} isError={props.isError}>
          <div>
            <div className="ads-selection--summary">
              {is.FilledText(props.customerName) ? (
                <div>
                  You are logged in as: <br />
                  {props.customerName}
                </div>
              ) : (
                <div>You are not logged in.</div>
              )}
              <h2 className="ads-selection--total">Current Total: {props.total}</h2>
            </div>
            <div className="ads-selection--record-container">
              {props.ads.map((ad, index) => (
                <AdsSelectionRecord index={index} key={ad.id} />
              ))}
            </div>
            <div className="ads-selection--toolbar">
              <Button
                onClick={props.invokeAddAd}
                disabled={props.isBusy || props.isError}
                data-testid="add-btn"
              >
                Add Ads
              </Button>
              <h2 className="ads-selection--total">Current Total: {props.total}</h2>
            </div>
            <ButtonContainer>
              <Button
                onClick={props.invokeCheckout}
                primary={true}
                fullWidth={true}
                disabled={props.ads.length === 0}
                data-testid="checkout-btn"
              >
                Check Out
              </Button>
            </ButtonContainer>
          </div>
        </BusyContainer>
      </main>
    );
  }

  componentDidMount() {
    this.props.onMount();
  }
}

interface IStoreProps {
  ads: IAdsInfo[];
  customerName: string;
  isBusy: boolean;
  isError: boolean;
  total: string;
  error: string;
}

interface IDispatchProps {
  onMount: () => void;
  invokeAddAd: () => void;
  invokeCheckout: () => void;
}

type IProps = IStoreProps & IDispatchProps;

const mapStates = (state: IStore): IStoreProps => ({
  ads: selectAds(state),
  customerName: selectCustomerName(state),
  isBusy: selectIsBusy(state),
  isError: selectIsError(state),
  total: formatMoney(selectTotal(state)),
  error: selectErrorMessage(state)
});

const mapDispatch = (dispatch: any): IDispatchProps => ({
  onMount: () => dispatch(adsCheckoutActionCreator.InitSelection()),
  invokeAddAd: () => dispatch(adsCheckoutActionCreator.AddAds()),
  invokeCheckout: () => dispatch(adsCheckoutActionCreator.Checkout())
});

export const AdsSelectionPage = connect(
  mapStates,
  mapDispatch
)(AdsSelectionPageContainer);



// WEBPACK FOOTER //
// ./src/modules/ads-checkout/components/AdsSelectionPage.tsx